import { render, staticRenderFns } from "./BoxIcon.vue?vue&type=template&id=d647a904&scoped=true&"
var script = {}
import style0 from "./BoxIcon.vue?vue&type=style&index=0&id=d647a904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d647a904",
  null
  
)

export default component.exports